import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const serviceIndépendant = {
	associatedRule: 'entreprise . activité . libérale . réglementée = non',
	url: 'https://www.urssaf.fr/accueil/services/services-independants/service-acplnr.html',
	title:
		'Le service Artisan, Commerçant et Profession libérale non réglementée',
	description:
		'L’Urssaf met à votre disposition un service en ligne. Il vous permet de gérer votre activité, contacter un conseiller et retrouver tous vos documents.',
	ctaLabel: 'Accéder au service',
	ariaLabel: 'Accéder au service sur urssaf.fr, nouvelle fenêtre',
	logo: URSSAF,
}
